import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { ReportsComponent } from './reports/reports.component';
import { TeamsComponent } from './teams/teams.component';
import { SettingsComponent } from './settings/settings.component';
import { UsersComponent } from './users/users.component';
import { NotpermitedComponent } from './notpermited/notpermited.component';
import { SalesModuleComponent } from './sales-module/sales-module.component';
import { ChargesModuleComponent } from './charges-module/charges-module.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'notpermited', component: NotpermitedComponent },
  { path: 'users/:cnpj', component: UsersComponent },
  { path: 'teams/:cnpj', component: TeamsComponent },
  { path: 'dash/:cnpj', component: DashboardComponent },
  { path: 'salesmodule/:cnpj', component: SalesModuleComponent },
  { path: 'chargesmodule/:cnpj', component: ChargesModuleComponent },
  { path: 'reports/:cnpj', component: ReportsComponent },
  { path: 'settings/:cnpj', component: SettingsComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
